import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  menus = [
    {
      title: 'Weave',
      link: '',
      submenus: [
        { title: 'GLOBAL.WEAVE.GLANCE', link: '/weave_glance' },
        {
          title: 'GLOBAL.WEAVE.PRODUCT_SERVICES',
          link: '/weave_product_services',
        },
        { title: 'GLOBAL.WEAVE.JAVA_BACKBONE', link: '/weave_java_backbone' },
      ],
    },
    {
      title: 'GLOBAL.COMPANY.ABOUT_US',
      link: '/company',
      submenus: [
        { title: 'GLOBAL.COMPANY.ABOUT_US', link: '/company/about' },
        {
          title: 'GLOBAL.COMPANY.VISION_MISSION',
          link: '/company/vision_mission',
        },
        { title: 'GLOBAL.COMPANY.HISTORY', link: '/company/history' },
        {
          title: 'GLOBAL.COMPANY.COMPANY_STRUCTURE',
          link: '/company/company_structure',
        },
        { title: 'GLOBAL.COMPANY.MANAGEMENT', link: '/company/management' },
        {
          title: 'GLOBAL.COMPANY.COMPANY_PROFILE',
          link: '/company/company_profile',
        },
        {
          title: 'GLOBAL.COMPANY.FINANCIAL_REPORT',
          link: '/company/financial_report',
        },
      ],
    },
    {
      title: 'GLOBAL.PRODUCT_SERVICES.PRODUCT_SERVICES',
      link: '/product',
      class: 'product',
      submenus: [
        {
          title: 'GLOBAL.PRODUCT_SERVICES.LEASED_CORE',
          link: '/product/leased_core',
        },
        {
          title: 'GLOBAL.PRODUCT_SERVICES.LEASED_LINE',
          link: '/product/leased_line',
        },
        {
          title: 'GLOBAL.PRODUCT_SERVICES.COLOCATION',
          link: '/product/colocation',
        },
        { title: 'GLOBAL.PRODUCT_SERVICES.CDN', link: '/product/cdn' },
        {
          title: 'GLOBAL.PRODUCT_SERVICES.TOWER_FIBERIZATION',
          link: '/product/tower_fiberization',
        },
        // { title: 'GLOBAL.PRODUCT_SERVICES.IP_TRANSIT', link: '/product/ip_transit' }
      ],
    },
    {
      title: 'GLOBAL.COVERAGE.COVERAGE',
      link: '/coverage',
      class: 'coverage',
      submenus: [
        { title: 'GLOBAL.COVERAGE.JAVA_BACKBONE', link: '/coverage/backbone' },
        // { title: 'Check Availability Network', link: '' },
        // { title: 'GLOBAL.COVERAGE.ORDER_FORM', link: '/coverage/order_form' },
        // { title: 'Network Monitoring Tools', link: '' }
      ],
    },
    {
      title: 'GLOBAL.NEWS.NEWS',
      link: '/news',
      class: 'news',
      submenus: [
        { title: 'GLOBAL.NEWS.PRESS_RELEASE', link: '/news' },
        { title: 'GLOBAL.NEWS.PROMOTION', link: '/news' },
        { title: 'GLOBAL.NEWS.CAREER', link: '/news' },
      ],
    },
    // {
    //   title: 'Support',
    //   submenus: [
    //     { title: 'Customer Portal', link: '' },
    //     { title: 'How To', link: '' }
    //   ]
    // }
  ];

  constructor() {}

  ngOnInit(): void {}
}
